import { init as initFacebookLogin } from '../../../components/auth/facebook-login/facebook-login';
import { init as initGoogleLogin } from '../../../components/auth/google-login/google-login';
import { waitAndReload } from '../../../components/auth/redirects';
import { init as initSignInWithApple } from '../../../components/auth/sign-in-with-apple/sign-in-with-apple';

declare class ApiSignupHelper {
  static BAD_EMAIL_CODE: number;
  static BAD_PASSWORD_CODE: number;
  static BAD_REQUEST_PARAMS: number;
  static USER_ALREADY_EXISTS: number;
  static INVALID_PASSWORD: 12;
  constructor(
    email: string,
    password: string,
    firstName: string,
    lastName: string
  );
  submit(): JQuery.Promise<void>;
}

declare global {
  const ApiSignupHelper: ApiSignupHelper;
}

const isMobile = window.matchMedia(
  'only screen and (max-device-width: 800px)'
).matches;
const ua = navigator.userAgent;
const iOS = /iPad|iPhone|iPod/.test(ua);
const iOS11 = /OS 11_/.test(ua);
const recent_iOS = isMobile === true && iOS === true && iOS11 === true;

// making sure ajax don't fail
// This is already in base_v3.coffee we are either overriding it or setting depending
// on which runs first.
$.ajaxSetup({
  xhrFields: {
    withCredentials: true,
  },
  beforeSend: function (xhr, settings: { type: string }) {
    xhr.setRequestHeader(
      'AUTHORIZATION',
      'c61de580-e48d-41d2-a8d1-6cd1429987a1'
    );
    if (!/^(GET|HEAD|OPTIONS|TRACE)$/.test(settings.type) && this.crossDomain) {
      // We need to re-fetch the cookie here every time just in case we have logged in the user without
      // a page refresh (as it happened when exp_22 came in. See: https://www.pivotaltracker.com/story/show/163027230)
      xhr.setRequestHeader('X-CSRFToken', $.cookie('csrftoken'));
    }
  },
});

// Login
const $login = $('#login-wrapper');
const $signup = $('#signup-wrapper');
$('a.login-button')
  .add('.login-header-btn')
  .on('click', (evt) => {
    evt.preventDefault();
    ga('send', 'event', 'login', 'open');
    $login.show();
  });

$login.find('form').on('submit', (evt) => {
  ga('send', 'event', 'login', 'submit');
  evt.preventDefault();
  const options = {
    email: $login.find('input[name="email"]').val(),
    password: $login.find('input[name="password"]').val(),
  };

  $.ajax({
    type: 'POST',
    url: '/api/login/',
    data: options,
    success: (data) => {
      ga('send', 'event', 'login', 'success');
      $('.require-signup').removeClass('require-signup');
      $login
        .find('button[type="submit"]')
        .prop('disabled', true)
        .text('Loading...');
      $login.find('.facebook-login').addClass('disabled');

      if (typeof dataLayer.push === 'function') {
        dataLayer.push({
          event: 'hr.login.success',
          login: {
            method: 'email',
          },
          customer: {
            id: data.id,
            email: data.email,
          },
        });
      }

      waitAndReload();
    },
    error: () => {
      ga('send', 'event', 'login', 'failure');
      $login.find('.login-error').show();
      $login.find('.dialog').effect('shake', { times: 3, displace: 10 });
    },
  });
  return false;
});

// Show login modal when a logged out user is redirected to '/'
if ($('#show_login').length) {
  $login.show();
}

$login.find('.close').on('click', () => {
  ga('send', 'event', 'login', 'close');
  $login.find('.error').hide();
  $login.find('button[type="submit"]').prop('disabled', false);
  $login.find('.facebook-login').removeClass('disabled');
  $login.fadeOut();
  if (recent_iOS === true) {
    $('body').css('position', 'static');
  }
});

initGoogleLogin({
  $wrapper: $(
    '#login-wrapper, #signup-wrapper, #signup-page, #welcome-pg'
  ).find('.google-login-button'),
  $login,
  $errorContainer: $login.find('.google-login-error'),
});

initFacebookLogin({
  $wrapper: $(
    '#login-wrapper, #signup-wrapper, #signup-page, #welcome-pg'
  ).find('.facebook-login'),
  $login,
  $errorContainer: $login.find('.fb-login-error'),
});

// Apple login
if (window.AppleID) {
  const { APPLE_CLIENT_ID_WEB, APPLE_SCOPE, APPLE_REDIRECT_URI, APPLE_STATE } =
    window as unknown as {
      APPLE_CLIENT_ID_WEB: string;
      APPLE_SCOPE: string;
      APPLE_REDIRECT_URI: string;
      APPLE_STATE: string;
    };

  initSignInWithApple({
    init: {
      clientId: APPLE_CLIENT_ID_WEB,
      scope: APPLE_SCOPE,
      redirectURI: APPLE_REDIRECT_URI,
      state: APPLE_STATE,
    },
    $login,
  });
}

const $show_password_signup = $('.signup-password-display-confirm');
$show_password_signup.on('click', () => {
  const pwEleType = $('.pw-input').attr('type');
  if (pwEleType === 'password') {
    $('.pw-input').attr('type', 'text');
  } else {
    $('.pw-input').attr('type', 'password');
  }

  $('#signup-password-display-confirm-show').toggle();
  $('#signup-password-display-confirm-hide').toggle();
});

$signup.find('a.login').on('click', () => {
  ga('send', 'event', 'signup', 'switch');
  $signup.find('.error').hide();
  $signup.find('button[type="submit"]').prop('disabled', false);
  $signup.find('.facebook-login').removeClass('disabled');
  $signup.find('.dialog').effect('puff', {
    percent: 120,
    complete: () => {
      $signup.hide();
      $signup.find('.dialog').show();
      $login.show();
    },
  });
});

$signup
  .find('form')
  .add('.signup-header-btn-ajax')
  .on('submit', (evt) => {
    evt.preventDefault();
    $signup.find('.error').hide();
    $signup.find('button[type="submit"]').prop('disabled', true);
    $signup.find('.facebook-login').addClass('disabled');
    const signup_helper = new ApiSignupHelper(
      $signup.find('input[name="email"]').val() as string,
      $signup.find('input[name="password"]').val() as string,
      $signup.find('input[name="first-name"]').val() as string,
      $signup.find('input[name="last-name"]').val() as string
    );
    const signup_promise = signup_helper.submit();
    signup_promise.done(() => {
      $('.require-signup').removeClass('require-signup');
      waitAndReload();
    });

    signup_promise.fail((data: { errors: number[] }) => {
      if (ApiSignupHelper.BAD_EMAIL_CODE in data.errors) {
        $signup.find('.incorrect-email').show();
      } else if (ApiSignupHelper.BAD_PASSWORD_CODE in data.errors) {
        $signup.find('.missing').show();
      } else if (data.errors.indexOf(ApiSignupHelper.INVALID_PASSWORD) > -1) {
        $signup
          .find('.missing')
          .text(
            'Password must be at least 8 characters long and difficult to guess.'
          )
          .show();
      } else if (ApiSignupHelper.BAD_REQUEST_PARAMS in data.errors) {
        $signup.find('.bad-request').show();
      } else if (ApiSignupHelper.USER_ALREADY_EXISTS in data.errors) {
        $signup.find('.duplicate').show();
      } else {
        $signup.find('.bad-server-reply').show();
      }
      $signup.find('.dialog').effect('shake', { times: 3, displace: 10 });
    });
    signup_promise.always(() => {
      $signup.find('button[type="submit"]').prop('disabled', false);
      $signup.find('.facebook-login').removeClass('disabled');
    });
    return false;
  });

$signup.find('.close').on('click', () => {
  ga('send', 'event', 'signup', 'close');
  $signup.find('.error').hide();
  $signup.find('button[type="submit"]').prop('disabled', false);
  $signup.find('.facebook-login').removeClass('disabled');
  $signup.fadeOut();
  if (recent_iOS) {
    $('body').css('position', 'static');
  }
});
